var _desc, _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgComplete(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "62px",
    height: "62px",
    viewBox: "0 0 62 62",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Yes") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "start",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "portal---consider-non---a",
    transform: "translate(-585.000000, -247.000000)",
    stroke: "#043F93",
    strokeWidth: 2
  }, /*#__PURE__*/React.createElement("g", {
    id: "mesg",
    transform: "translate(166.000000, 181.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Yes",
    transform: "translate(420.000000, 67.000000)"
  }, /*#__PURE__*/React.createElement("circle", {
    id: "Oval-1788",
    cx: 30,
    cy: 30,
    r: 30
  }), /*#__PURE__*/React.createElement("polyline", {
    id: "Line-401",
    transform: "translate(29.780511, 30.181398) scale(1, -1) rotate(-75.000000) translate(-29.780511, -30.181398) ",
    points: "19.5711342 42.8598923 39.9898875 25.4432104 29.7805108 17.5029038"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgComplete);
export default __webpack_public_path__ + "static/media/Complete.96fa7c0808d3028da5a531f6f8f3b417.svg";
export { ForwardRef as ReactComponent };